export default {
  OK: "OK",
  ok: "OK",
  loginFailed: "Login failed, please try again.",
  requestFailed: "Request failed, please check your internet connection.",
  invalidLogin: "Invalid Username or Password.",
  invalidPassword: "Invalid Username or Password.",
  thisFunctionExists: "This function is already exists.",
  thisFunctionNotAllowDelete: "This function is not allow to delete.",
  thisFunctionNotExists: "This function is not exists.",
  targetFunctionIdRequired: "Target Function ID is required.",
  thisPageExists: "This page is already exists.",
  thisPageNotAllowDelete: "This page is not allow to delete.",
  thisRoleExists: "This role is already exists.",
  thisRoleNotAllowDelete: "This role is not allow to delete.",
  targetRoleIdRequired: "Target Role ID is required.",
  invalidParameter: "Invalid Parameter.",
  systemError: "System unable to process your request.",
  spErrorMessage: "SP Message Error (Depend what error).",
  actionbyRequired: "Current User is required.",
  sessionTokenRequired: "Session Token is required.",
  functionIdRequired: "Function ID is required.",
  functionNameRequired: "Function name is required.",
  newFunctionNameRequired: "Function name is required.",
  pageIdRequired: "Page ID is required.",
  newPageIdRequired: "Page ID is required.",
  newPageNameRequired: "Page name is required.",
  targetPageIdRequired: "Target Page ID is required.",
  userIdRequired: "User ID is required",
  passwordRequired: "Password is required.",
  userNameRequired: "Full Name is required.",
  passwordValidation: "Password must be 6-20 characters and a combination of number(s) and letter(s).",
  pageNumRequired: "Page Number is required.",
  pageSizeRequired: "Page Size is required.",
  roleIdRequired: "Role ID is required",
  oldPasswordRequired: "Current Password is required.",
  userStatusRequired: "User Status is required.",
  newRoleIdRequired: "Role ID is required.",
  newRoleNameRequired: "Role Name is required.",
  startDateRequired: "Start Date is required.",
  endDateRequired: "End Date is required.",
  startDateIsGteEndDate: "Start Date is greater than End Date.",
  sportsTypeRequired: "Sports Type is required.",
  teamTypeRequired: "Team Type is required.",
  thisRoleNotExists: "This Role is not exists.",
  thisPageNotExists: "This Page is not exists.",
  thisUserExists: "This User is already exists.",
  thisUserNotExists: "This User is not exists.",
  thisUserBlackListed: "Your account has been suspended.",
  thisUserInactive: "Your account has been disabled.",
  thisUserBlocked: "Your account has been blocked.",
  thisUserNotActive: "Your account has been disabled.",
  InvalidPageFunction:"Invalid Page Function.",
  invalidUser: "Invalid User!",
  invalidToken: "Invalid Session!",
  NoUserAccessRight: "Permission Denied!",
  unableSPProcess: "System unable to process your request.",
  connection: "Connection Error",

  isRequired: "Please enter a {fname}.",
  isMinValue: "{fname} must have minimal of {fvalue}.",
  isMaxValue: "{fname} must be less than or equal to {fvalue}.",
  isMinLength: "{fname} must have at least {fvalue} characters.",
  isMaxLength: "{fname} must be less than or equal to {fvalue} characters.",
  isAlpha: "{fname} accept only alphabet.",
  isAlphaNum: "{fname} accept only alphanumerics.",
  isNumeric: "{fname} accept only numerics.",
  isEmail: "{fname} accept only valid email addresses.",
  isIpAddress: "{fname} accept only valid IPv4 addresses.",
  isSameAs: "{fname} must be same as {fname2}.",
  isUrl: "{fname} accept only URLs.",
  containAlphaNum: "{fname} must have at least one alphabet and one number.",
  selectOption: "Please select a {fname}",
  notSameAs: "{fname} and {fname2} cannot be the same.",
  isBetween: "{fname} must be between {min} and {max}.",
  isSSFormat: "Invalid Super Senior account id format.",
  isReserved: "Reserved account id.",
  isExisted: "Account id existed.",
  onlySmallCapsAlphaNum: "Only small capitals from a to z and 0 to 9 allowed",

  system_error: "System unable to process your request.",
  invalid_password: "Invalid Username or Password.",
  block: "Your account has been blocked.",
  invalid_security_code: "Invalid security code.",

  source_account_id_required: "Account ID is required.",
  target_account_id_required: "Target account ID is required.",
  permission_denied: "No permission allowed.",
  account_id_required: "Account ID is required.",
  sub_login_id_required: "Login ID is required.",
  account_not_exists: "Account does not exists.",
  profile_not_exists: "Profile does not exists.",
  account_inactive: "Inactive account.",
  not_blocked_account: "Valid account.",
  password_required: "Password is required.",
  parent_id_required: "Parent ID is required.",
  parent_not_exists:"Parent ID does not exists.",
  invalid_account_type: "Invalid account type.",
  account_exists: "Account is already exists.",
  login_id_required: "Login ID is required.",
  new_login_id_required: "New login ID is required.",
  login_id_not_exists: "Login ID does not exists.",
  invalid_authority_role: "Invalid role.",
  profile_inactive: "Invalid profile.",
  secondary_account_exists: "Secondary account is already exists.",
  new_login_id_exists: "New login ID is already exists.",
  new_password_required: "New password is required.",
  security_tag_required: "Security tag is required.",
  security_code_required: "Security code is required.",
  start_date_required: "Start date is required.",
  end_date_required: "End date is required.",
  start_date_gt_end_date: "Start date is greater than end date.",
  member_id_required: "Member ID is required.",
  currency_code_required: "Currency code is required.",
  bet_type_required: "Bet type is required.",
  invalid_bet_type: "Invalid bet type.",
  match_id_required: "Match ID is required.",
  invalid_match_id: "Invalid Match ID.",
  invalid_home_running_score: "Invalid Home Running Score.",
  invalid_away_running_score: "Invalid Away Running Score.",
  invalid_home_away: "Invalid Home Away.",

  validAmount: "Please enter a valid amount",

  no_match_selected: "No match selected",
  invalid_room_rate: "Invalid Room Rate",
  invalid_room_limit: "Invalid Room Limit",
  no_currency_selected: "Please select a Currency",

  valid: "{fname} contains at least One Uppercase, One Lowercase and One Number.(Eg: Abcd1234)",
  notSame: "New password can not be same with Old password."
};
